import api from "../axios";
import { type InvitesResponse } from "./types";

export class ApiInvites {
  getInvites() {
    return api.get<InvitesResponse>("/suppliers/employees/invites/me");
  }

  acceptInvite(inviteId: string) {
    return api.post(`/suppliers/employees/invites/${inviteId}/accept`);
  }

  declineInvite(inviteId: string) {
    return api.post(`/suppliers/employees/invites/${inviteId}/decline`);
  }
}
